import {
  BackgroundPreset,
  ViewerPreferenceSettings,
} from './viewer-preference-types';

const TRIMBLE_GRAY = '#363545';
const WHITE = '#FFFFFF';

export const TEXT_COLOR_ON_LIGHT = TRIMBLE_GRAY;
export const TEXT_COLOR_ON_DARK = WHITE;

export const BACKGROUND_PRESETS: readonly BackgroundPreset[] = [
  {
    id: 'white',
    topColor: '#FFFFFF',
    bottomColor: '#FEFEFE',
    textColor: TRIMBLE_GRAY,
    darkModeMaterials: false,
  },
  {
    id: 'gray-light',
    topColor: '#F3F3F7',
    bottomColor: '#F2F2F6',
    textColor: TRIMBLE_GRAY,
    darkModeMaterials: false,
  },
  {
    id: '3d-default',
    topColor: '#EEEEEE',
    bottomColor: '#EDEDED',
    textColor: TRIMBLE_GRAY,
    darkModeMaterials: false,
  },
  {
    id: 'gray-1',
    topColor: '#E2E2E7',
    bottomColor: '#E1E1E6',
    textColor: TRIMBLE_GRAY,
    darkModeMaterials: false,
  },
  {
    id: 'gray-2',
    topColor: '#D0D0D7',
    bottomColor: '#CFCFD6',
    textColor: TRIMBLE_GRAY,
    darkModeMaterials: false,
  },
  {
    id: 'gray-3',
    topColor: '#BFBFC6',
    bottomColor: '#BEBEC5',
    textColor: TRIMBLE_GRAY,
    darkModeMaterials: false,
  },
  {
    id: 'gray-dark',
    topColor: '#1B1A26',
    bottomColor: '#1B1A26',
    textColor: WHITE,
    darkModeMaterials: true,
  },
];

export const CUT_EDGE_HIGHLIGHT_COLORS: readonly string[] = [
  '#00F5C4',
  '#EF11FA',
  '#001EE0',
  '#5CE000',
  '#FFCC00',
  '#FFECC4',
  '#BDF3F6',
  '#F57B00',
  '#BACAFF',
];

export const DEFAULT_HIGHLIGHT_COLOR = '#00F5C4';

// Fresh users keep mobile-mapping's prior light background; it isn't a Connect
// preset, so it appears as the selected "Custom" swatch.
export const DEFAULT_VIEWER_PREFERENCE_SETTINGS: ViewerPreferenceSettings = {
  backgroundTopColor: '#f1f1f6',
  backgroundBottomColor: '#e0e1e9',
  textColor: '#252a2e',
  darkModeMaterials: false,
  clippingHighlightColor: DEFAULT_HIGHLIGHT_COLOR,
};
